// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringUtils } from '@shared/util/string-utils';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CustomValidators } from '@shared/custom-validators';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';

@Component({
  standalone: false,
  selector: 'edit-description',
  templateUrl: './edit-description.component.html',
})
export class EditDescriptionComponent implements OnInit {
  @Input() description: string = '';
  @Output() public finish = new EventEmitter<{ success: boolean, data: string }>();

  public title: string = '';

  public form: FormGroup;

  constructor(private fb: FormBuilder, private bsModalRef: BsModalRef, private localeResourceManager: LocaleResourceManager) {}

  public ngOnInit(): void {
    this.title = StringUtils.isEmpty(this.description) ? 'editDescriptionPopup.title.new' : 'editDescriptionPopup.title.edit';
    this.form = this.fb.group({
      description: [this.description, CustomValidators.defaultNameValidator(this.localeResourceManager, { required: false })],
    });
  }

  public close(success: boolean = false): void {
    this.bsModalRef.hide();
    this.finish.emit({
      success: success,
      data: this.description,
    });
  }

  public accept(): void {
    if (this.form.invalid) {
      return;
    }
    const description: string = this.form.controls.description.value;
    if (StringUtils.isEmpty(description)) {
      this.description = null;
    } else {
      this.description = description;
    }
    this.close(true);
  }
}
